module.exports = __webpack_public_path__ + "static/img/2.98cf54c8.jpg";